import { useEffect, useState } from 'react';
import { CSV } from '../../util/ExportFile';
import { Employee } from "../../model/Employee";
import { 
  DetailEmployeeModal, AddEmployeeModal, EditEmployeeModal,
  RenderTableKaryawan, fetchGetKaryawanAll,
} from '../../controller/dashboard/DataKaryawan';
import { 
  Users, 
  Plus, 
  Search, 
  Filter,
  ListOrdered,
  Calendar,
  User,
  Download,
  RotateCcw
} from 'lucide-react';

export default function DashboardDataKaryawan() {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 
  const [statusFilter, setStatusFilter] = useState('all');
  const [statusLength, setStatusLength] = useState('10');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [employeeData, setEmployeeData] = useState<Employee[]>([]);
  const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);

  const filteredEmployees = employeeData.filter(emp => {
    const matchesSearch =
      emp.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      emp.nik.includes(searchTerm) ||
      emp.name.includes(searchTerm);
    const matchesStatus = statusFilter === 'all' || emp.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEmployees = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);
  let totalPages = itemsPerPage > 0 ? Math.ceil(filteredEmployees.length / itemsPerPage) : 0;
  const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

  const initDataKaryawan = async () => { 
    setLoading(true);

    try {
      const res = await fetchGetKaryawanAll();
      if (res.status === 200) {
        setEmployeeData(res.data); // pastikan API kirim data array karyawan
      } else {
        setEmployeeData([]);
      }
    } catch (error) {
      console.error(error);

      setEmployeeData([]);
    } finally {
      setLoading(false);
    }
  }

  const handleShowDetail = (karyawan: Employee) => {
    setSelectedEmployee(karyawan);
    setShowDetailModal(true);
  };

  const handleEditDetail = (karyawan: Employee) => {
    setSelectedEmployee(karyawan);
    setShowEditModal(true);
  };

  useEffect(() => {
    initDataKaryawan();
    setItemsPerPage(Number(statusLength === 'all' ? employeeData.length : statusLength))
  }, [employeeData, statusLength, totalPages]);

  return (
    <>
      <div className="min-h-screen p-6">
        <div className="max-w-8xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <Users className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <h1 className="text-3xl font-bold">Pendataan Karyawan</h1>
                <p>Kelola data karyawan dan informasi kontrak</p>
              </div>
            </div>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Total Karyawan</p>
                    <p className="text-2xl font-bold text-blue-600">{employeeData.length}</p>
                  </div>
                  <div className="p-3 bg-blue-100 rounded-xl">
                    <Users className="w-6 h-6 text-blue-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Karyawan Tetap</p>
                    <p className="text-2xl font-bold text-green-600">
                      {employeeData.filter(e => e.status === 'organic').length}
                    </p>
                  </div>
                  <div className="p-3 bg-green-100 rounded-xl">
                    <User className="w-6 h-6 text-green-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Karyawan Kontrak</p>
                    <p className="text-2xl font-bold text-orange-600">
                      {employeeData.filter(e => e.status === 'kontrak').length}
                    </p>
                  </div>
                  <div className="p-3 bg-orange-100 rounded-xl">
                    <Calendar className="w-6 h-6 text-orange-600" />
                  </div>
                </div>
              </div>

              {/* <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Kontrak 2025</p>
                    <p className="text-2xl font-bold text-purple-600">
                      {employeeData.filter(e => e.contractYear === 2024).length}
                    </p>
                  </div>
                  <div className="p-3 bg-purple-100 rounded-xl">
                    <FileText className="w-6 h-6 text-purple-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Kontrak Selain Tahun ini</p>
                    <p className="text-2xl font-bold text-purple-600">
                      {employeeData.filter(e => e.contractYear !== 2024).length}
                    </p>
                  </div>
                  <div className="p-3 bg-purple-100 rounded-xl">
                    <FileText className="w-6 h-6 text-purple-600" />
                  </div>
                </div>
              </div> */}

            </div>
          </div>

          {/* Controls */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4">
              <div className="flex flex-row gap-4 justify-center">
                {/* Search */}
                <div className="relative w-full">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type="text"
                    placeholder="Masukkan nama atau NIK"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent h-full xl:w-64 md:w-full"
                  />
                </div>

                {/* Filter */}
                <div className="relative w-full">
                  <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent h-full xl:w-48 md:w-full"
                  >
                    <option value="all">Semua Status</option>
                    <option value="organic">Karyawan Tetap</option>
                    <option value="kontrak">Kontrak</option>
                  </select>
                </div>

                {/* Length*/}
                <div className="relative w-full">
                  <ListOrdered className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <select
                    value={statusLength}
                    onChange={(e) => {setStatusLength(e.target.value); setItemsPerPage(Number(e.target.value === 'all' ? employeeData.length : e.target.value))}}
                    className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent h-full xl:w-24 md:w-full"
                  >
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option> 
                    <option value="500">500</option>
                    <option value="all">Tampil Semua</option>
                  </select>
                </div>
              </div>

              <div className="flex flex-row gap-4">
                <button 
                  onClick={initDataKaryawan}
                  disabled={loading}
                  className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors xl:w-40 md:w-full">
                  <RotateCcw className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`} />
                  {loading ? "Memuat..." : "Muat Ulang"}
                </button>

                <button 
                  onClick={() => CSV(employeeData, "Export_Karyawan")}
                  className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors xl:w-40 md:w-full">
                  <Download className="w-4 h-4 mr-2" />
                  Export
                </button>

                <button
                  onClick={() => setShowAddModal(true)}
                  className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors xl:w-56 md:w-full"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Tambah Karyawan
                </button>
              </div>
            </div>
          </div>

          {/* Employee Table */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Karyawan
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      NIK
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Posisi
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Tanggal Masuk
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Aksi
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {
                      loading ? (
                          <tr>
                            <td colSpan={6} className="text-center py-4 text-gray-500">
                              Sedang Loading...
                            </td>
                          </tr>
                      ) : (
                        <RenderTableKaryawan filteredData={currentEmployees} onOpenDetail={handleShowDetail} onOpenEdit={handleEditDetail} onRemoveState={initDataKaryawan} />
                      )
                    }
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="mt-6 flex items-center justify-between">
            <div className="text-sm text-gray-700">
              Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
              <span className="font-medium">{statusLength === "all" ? employeeData.length : statusLength}</span> dari{' '}
              <span className="font-medium">{employeeData.length}</span> karyawan
            </div>
            <div className="flex space-x-2">
              <button 
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => prev - 1)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                Previous
              </button>
              
              { pageNumbers.map((page) =>( 
                <button 
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
                  {page}
                </button>
              ))}
              
              <button 
                disabled={currentPage === Math.ceil(filteredEmployees.length / itemsPerPage)}
                onClick={() => setCurrentPage(prev => prev + 1)}
                className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                Next
              </button>
            </div>
          </div>
        </div>

        {/* Add Employee Modal */}
        {showAddModal && <AddEmployeeModal setShowAddModal={setShowAddModal} onPostState={initDataKaryawan}/>}

        {/* Detail Employee Modal */}
        {showDetailModal && <DetailEmployeeModal employeeDetail={selectedEmployee} stateShowModal={setShowDetailModal} />}

        {/* Detail Employee Modal */}
        {showEditModal && <EditEmployeeModal employeeDetail={selectedEmployee} stateShowModal={setShowEditModal} onEditState={initDataKaryawan}/>}
      </div>
    </>
  )
}
